import React from 'react';
import { Row, Col } from 'antd';
import { CoursesCard } from './CoursesCard';
import coursesData from './CoursesData';

export const BcDetails = () => {
    const bcData = coursesData.filter(info => info.id.includes('BC-101'));
    return (
        <div>
        <Row gutter={[16,16]}>
        {
            bcData.map((course)=> <Col>
             <CoursesCard src={course.image} title={course.name} desc={course.desc} key={course.id} />
         </Col>)
        }
         
            
        </Row>
     
    </div>
    )
}
